import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import StickyBox from "react-sticky-box";
import IntroducePortfolio from "./IntroducePortfolio";
import PortfolioBodyHeader from "./PortfolioBodyHeader";
import PortfolioListSection from "./PortfolioListSection";
import { PORTFOLIO_TABS } from "../constants/portfolioConstants";

const STICKY_OFFSET_TOP = 72;

export default function PortfolioMobileContent({
  dashboard,
  category,
  onSelectTab,
  onBack,
  activeTabIndex,
  tabActive,
  introduceModel,
  buildListModel,
  onSwiper,
  onSlideChange,
}) {
  return (
    <Swiper
      className="chat-body portfolio-mobile-swiper portfolio-mobile-swiper-shell"
      slidesPerView={1}
      resistanceRatio={0.35}
      threshold={6}
      speed={350}
      grabCursor
      allowTouchMove
      touchEventsTarget="container"
      watchOverflow
      observer
      observeParents
      initialSlide={activeTabIndex}
      onSwiper={onSwiper}
      onSlideChange={onSlideChange}
    >
      <div slot="container-start">
        <StickyBox offsetTop={STICKY_OFFSET_TOP} className="portfolio-body-sticky">
          <PortfolioBodyHeader
            dashboard={dashboard}
            category={category}
            tabActive={tabActive}
            onSelectTab={onSelectTab}
            onBack={onBack}
          />
        </StickyBox>
      </div>

      {/* 소개 탭/목록 탭을 동일한 슬라이드 구조로 렌더링한다. */}
      {PORTFOLIO_TABS.map((tab) => (
        <SwiperSlide key={tab.key} className="portfolio-mobile-swiper-slide">
          <div className="chat-body-content portfolio-mobile-content-wrap">
            <div className="portfolio-mobile-slide-scroll">
              {tab.key === "introduce" ? (
                <IntroducePortfolio model={introduceModel} />
              ) : (
                <PortfolioListSection model={buildListModel(tab.key, tab.key === tabActive)} />
              )}
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
